/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Type_Automated_OnlyInputs */

const en_task_catalog_type_automated_only = /** @type {(inputs: Task_Catalog_Type_Automated_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created by automation only`)
};

const pt_br2_task_catalog_type_automated_only = /** @type {(inputs: Task_Catalog_Type_Automated_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criada somente pela automação`)
};

/**
* | output |
* | --- |
* | "Created by automation only" |
*
* @param {Task_Catalog_Type_Automated_OnlyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_type_automated_only = /** @type {((inputs?: Task_Catalog_Type_Automated_OnlyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Type_Automated_OnlyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_type_automated_only(inputs)
	return pt_br2_task_catalog_type_automated_only(inputs)
});